























































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeMultiple } from '@/components/molecules/InputCodeMultiple'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { systemCodeStore } from '@/utils/store-accessor'

export interface InputForwardingRequestItem {
  requestLevel: {
    input: SystemCode
    errorMessage: string
  }
  requestBranch: {
    input: SystemCode[]
    errorMessage: string
  }
  requestMemo: {
    input: string
    errorMessage: string
  }
}

export const defaultInputForwardingRequestItem = (): InputForwardingRequestItem => ({
  requestLevel: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  requestBranch: {
    input: [],
    errorMessage: ''
  },
  requestMemo: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    InputCodeMultiple,
    InputDatePicker
  }
})
export default class ForwardingRequestInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  internalInput!: InputForwardingRequestItem

  inputRequestMemoCode: SystemCode = defaultSystemCode()

  get forwardingRequestLevelItems(): SystemCode[] {
    return systemCodeStore.getForwardingRequestLevel
  }

  onInputRequestBranch(items: SystemCode[]) {
    this.internalInput.requestBranch.input = items
    this.internalInput.requestBranch.errorMessage = ''
  }

  onInputRequestMemoCode(input: SystemCode) {
    this.inputRequestMemoCode = input
    this.internalInput.requestMemo.input = input.name
    this.internalInput.requestMemo.errorMessage = ''
  }
}
